export default __webpack_public_path__ + "locales/lv/EmptyTrashDialog.json?hash=2dbadf27bc0aff0a32afbca9f067474a";